import { MascotCTA } from "@ecologi/react-components/src/MascotCTA";

export default function MascotCTAWidget(props: any) {
  return <MascotCTA {...props.data} colourWay={props.data.colour_way} />;
}
